export default {"src":"/_next/static/media/icon_play_events.42d969a6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};